import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoMessageComponent } from './info-message.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SvgIconModule,
    ],
    exports: [InfoMessageComponent],
    declarations: [InfoMessageComponent],
    entryComponents: [InfoMessageComponent],
})
export class InfoMessageModule { }
